<template>
    <transition name="page" mode="out-in">
        <div class="cover" v-if="loading">
            <div id="ballWrapper">
                 <div id="ball" class="loading-ball">
                    <span class="loader"></span>
                 </div> 
            </div>
        </div>
    </transition>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'spinner',

        computed: {
            ...mapGetters({settings: 'local/settings'}),

            loading() {
                return this.settings('loading')
            }
        }
    }
</script>

<style scoped>
.loader {
  position: absolute;
  width: 200px;
  height: 200px;
  z-index: 100;
  left: 50%;
  top: 0px;
  margin-left: -100px;
}
.loader:before , .loader:after{
  content: '';
  border-radius: 50%;
  position: absolute;
  inset: 0;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.3) inset;
}
.loader:after {
  box-shadow: 0 2px 0 #FF4500 inset;
  animation: rotate 2s linear infinite;
}
.cover {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background: #000;
    z-index: 1999;
}
#ballWrapper {
    width: 100px;
    height: 100px;
    position: fixed;
    left: 50%;
    top: 30%;
    margin-left: -100px;
    z-index: 100;
    transform: scale(1);
    cursor: pointer;
}
#ballWrapper:active {
    transform: scale(0);
    cursor: pointer;
}

.loading-ball {
    width: 198px;
    height: 198px;
    position: absolute;
    border-radius: 100%;
    background: #000 url("../../../img/identity/logo-pocket.png") no-repeat center/contain;
    top: 40%;
    z-index: 11;
    animation: wow 2s infinite;
    cursor: pointer;
    background-size: 90%;
}
@keyframes rotate {
  0% { transform: rotate(0) }
  100% { transform: rotate(360deg) }
}
@keyframes wow {
    0% {
        opacity: 0.2;
        animation-timing-function: ease-in;
    }
    50% {
        opacity: 1;
        animation-timing-function: ease-out;
    }
    100% {
        opacity: 0.2;
        animation-timing-function: ease-in;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/spinner/Spinner.vue